{
  "familyId": "MET-GEW-CONTEXT",
  "questions": [
    {
      "id": "MET-GEW-CONTEXT-001",
      "familyId": "MET-GEW-CONTEXT",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "gewicht",
      "subSkill": "gewicht_context",
      "questionType": "multiple_choice",
      "question": "Een recept vraagt om 1,5 kg aardappelen. Je hebt al 800 g. Hoeveel gram heb je nog nodig?",
      "options": ["700 g", "650 g", "1300 g", "200 g"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gewicht omrekenen",
            "content": "1,5 kg = 1500 g. Trek af wat je al hebt: 1500 − 800 = 700 g.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gewicht_context_recept",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Eerst reken je kilogram om naar gram: 1,5 kg = 1500 g. Waarom? Omdat je in dezelfde eenheid moet rekenen om af te trekken. Dan: 1500 − 800 = 700 g. Je hebt nog 700 g nodig. Klopt dit? 800 + 700 = 1500 g = 1,5 kg ✓.",
        "solutionSteps": [
          "Reken om: 1,5 kg = 1500 g",
          "Trek af wat je hebt: 1500 − 800 = 700 g",
          "Check: 800 + 700 = 1500 g ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 1500 − 800 = 700 g.",
          "1": "Je dacht waarschijnlijk dat 1,5 kg = 1450 g is. Maar 1,5 kg = 1500 g (niet 1450). Onthoud: 1 kg = 1000 g, dus 1,5 kg = 1500 g.",
          "2": "Je dacht waarschijnlijk dat je de 800 g erbij moest optellen. Maar je hebt al 800 g, dus je trekt af: 1500 − 800 = 700 g.",
          "3": "Je dacht waarschijnlijk dat 1,5 kg = 1000 g is. Maar 1,5 kg = 1500 g. Onthoud: de 0,5 kg = 500 g extra."
        }
      }
    },
    {
      "id": "MET-GEW-CONTEXT-002",
      "familyId": "MET-GEW-CONTEXT",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "gewicht",
      "subSkill": "gewicht_context",
      "questionType": "multiple_choice",
      "question": "Een koffer mag maximaal 23 kg wegen. De koffer zelf weegt 3,5 kg. Hoeveel kilogram spullen kun je erin doen?",
      "options": ["26,5 kg", "20,5 kg", "19,5 kg", "19 kg"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Maximaal gewicht",
            "content": "Het maximale gewicht is inclusief de koffer. Trek het gewicht van de koffer af: 23 − 3,5 = 19,5 kg.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gewicht_context_max",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het maximum is 23 kg inclusief de koffer. De koffer weegt 3,5 kg. Dus: 23 − 3,5 = 19,5 kg aan spullen.",
        "solutionSteps": [
          "Maximum: 23 kg (inclusief koffer)",
          "Koffer weegt: 3,5 kg",
          "Spullen: 23 − 3,5 = 19,5 kg"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je het koffergewicht erbij moest optellen. Maar de 23 kg is het maximum — je trekt de koffer eraf.",
          "1": "Je dacht waarschijnlijk dat je 23 − 2,5 moest rekenen. Maar de koffer weegt 3,5 kg, niet 2,5 kg. Lees de getallen goed.",
          "2": "Goed! 23 − 3,5 = 19,5 kg.",
          "3": "Je dacht waarschijnlijk dat 23 − 3,5 = 19 is. Maar 23 − 3 = 20, en 20 − 0,5 = 19,5. Onthoud: reken ook de halve kilo mee."
        }
      }
    },
    {
      "id": "MET-GEW-CONTEXT-003",
      "familyId": "MET-GEW-CONTEXT",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "gewicht",
      "subSkill": "gewicht_context",
      "questionType": "multiple_choice",
      "question": "Een pakketje weegt 450 g. Je mag maximaal 2 kg versturen. Hoeveel pakketjes kun je maximaal versturen?",
      "options": ["5 pakketjes", "4 pakketjes", "3 pakketjes", "2 pakketjes"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoeveel passen er in?",
            "content": "2 kg = 2000 g. Deel: 2000 ÷ 450 = 4,44... Je kunt geen halve pakketjes versturen, dus maximaal 4.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gewicht_context_verdelen",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "2 kg = 2000 g. Deel: 2000 ÷ 450 = 4,44... Je kunt geen halve pakketjes versturen. 4 × 450 = 1800 g (past). 5 × 450 = 2250 g (te zwaar). Dus maximaal 4.",
        "solutionSteps": [
          "Reken om: 2 kg = 2000 g",
          "Deel: 2000 ÷ 450 = 4,44...",
          "Rond af naar beneden: maximaal 4 pakketjes",
          "Check: 4 × 450 = 1800 g ≤ 2000 g ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je naar boven afrondt. Maar 5 × 450 = 2250 g, en dat is meer dan 2000 g. Bij 'maximaal' rond je naar beneden af.",
          "1": "Goed! 2000 ÷ 450 = 4,44... → maximaal 4 pakketjes.",
          "2": "Je dacht waarschijnlijk dat 450 g bijna 500 g is en 2000 ÷ 500 = 4, maar dan min 1. Maar 4 × 450 = 1800 g, dat past nog ruim.",
          "3": "Je dacht waarschijnlijk dat 2 kg = 1000 g is. Maar 2 kg = 2000 g. Onthoud: 1 kg = 1000 g."
        }
      }
    },
    {
      "id": "MET-GEW-CONTEXT-004",
      "familyId": "MET-GEW-CONTEXT",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "gewicht",
      "subSkill": "gewicht_context",
      "questionType": "multiple_choice",
      "question": "Een zak meel weegt 1 kg. Na het bakken heb je 350 g gebruikt. Hoeveel gram meel is er over?",
      "options": ["1350 g", "750 g", "350 g", "650 g"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Aftrekken van gewicht",
            "content": "1 kg = 1000 g. Trek het gebruikte deel af: 1000 − 350 = 650 g.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gewicht_context_rest",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Eerst reken je om: 1 kg = 1000 g. Waarom? Omdat de gebruikte hoeveelheid in gram staat, moet je in dezelfde eenheid werken. Dan trek je af: 1000 − 350 = 650 g. Klopt dit? 650 + 350 = 1000 g = 1 kg ✓.",
        "solutionSteps": [
          "Reken om: 1 kg = 1000 g",
          "Trek af: 1000 − 350 = 650 g",
          "Check: 650 + 350 = 1000 g ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je de 350 g erbij moest optellen. Maar je hebt meel gebruikt, dus je trekt af.",
          "1": "Je dacht waarschijnlijk dat 1000 − 350 = 750 is. Maar 1000 − 300 = 700, en 700 − 50 = 650. Controleer je aftreksom.",
          "2": "Je dacht waarschijnlijk dat de 350 g het antwoord is. Maar 350 g is wat je hebt gebruikt. De vraag is hoeveel er over is: 1000 − 350 = 650 g.",
          "3": "Goed! 1000 − 350 = 650 g."
        }
      }
    },
    {
      "id": "MET-GEW-CONTEXT-005",
      "familyId": "MET-GEW-CONTEXT",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "gewicht",
      "subSkill": "gewicht_context",
      "questionType": "fill_in",
      "question": "Een doos appels weegt 2,4 kg. Er zitten 8 appels in. Hoeveel gram weegt één appel? Typ je antwoord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["300", "300 g", "300g"],
        "caseSensitive": false,
        "placeholder": "... g"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gewicht per stuk",
            "content": "Reken eerst om naar gram: 2,4 kg = 2400 g. Deel dan door het aantal: 2400 ÷ 8 = 300 g per appel.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "gewicht_context_per_stuk",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "2,4 kg = 2400 g. Deel door 8 appels: 2400 ÷ 8 = 300 g. Eén appel weegt 300 g.",
        "solutionSteps": [
          "Reken om: 2,4 kg = 2400 g",
          "Deel door het aantal: 2400 ÷ 8 = 300 g",
          "Eén appel weegt 300 g"
        ]
      }
    }
  ]
}